/*
 * @Author: Ning
 * @Date: ****** 13:23:08
 * @LastEditTime: 2020-09-09 14:38:05
 * @LastEditors: Ning
 * @Description: System Logs 日志
 * @Do not edit
 */
import { combineReducers } from "redux";
import userLoginInfo from './userLoginInfo';

export default combineReducers({
    userLoginInfo:userLoginInfo,
})
